import { render, staticRenderFns } from "./StorageLocations.vue?vue&type=template&id=1e2507e2&scoped=true&lang=pug&"
import script from "./StorageLocations.vue?vue&type=script&lang=js&"
export * from "./StorageLocations.vue?vue&type=script&lang=js&"
import style0 from "./StorageLocations.vue?vue&type=style&index=0&id=1e2507e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2507e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCol,VDivider,VList,VListItem,VListItemTitle,VMenu,VRow,VSkeletonLoader})
